module.exports = __webpack_public_path__ + "img/azerion.1f711331.svg";